import React from "react";
import "./excluded-ship-states.scss";

function ExcludedShipStateMessage({ fulfillmentDetails }) {
  const { shippingExclusion, discontinuedItem } = fulfillmentDetails;



  if (shippingExclusion && shippingExclusion.hasExclusionLocations && !discontinuedItem && !fulfillmentDetails.proInstallSelected) {
    let excludedStates = null, bossExclusionLocations=null;
    try {
      if (shippingExclusion.exclusionLocations) {
        excludedStates = shippingExclusion.exclusionLocations.map(state => (
          <span className="excludedStates" key={state}>
            {state}
          </span>
        ));
      }
      if (shippingExclusion.bossExclusionLocations) {
        bossExclusionLocations = shippingExclusion.bossExclusionLocations.map(
          state => (
            <span className="excludedStates" key={state}>
              {state}
            </span>
          )
        );
      }
    } catch(e) {
      console.error(e);
    }

    if (!shippingExclusion.hasSeparateBossSthExclusionLocations) {
      return (
        <div className="u__text-align--left u__p-top--small buybelt__cannot_be_shipped excludedStateTopPadding">
          <div className="buybelt__cannot_be_shipped__wrapper single-message-for-excluded-state">
            <span className="icon-not--available icon-no--sth"></span>
            <span className="icon-not--available icon-no--boss double-icons"></span>
            <span className="u__p-right--xsmall u__p-left--small">
              &nbsp;We're unable to ship this item to homes and stores in:&nbsp;
            </span>
            {excludedStates}
          </div>
        </div>
      );
    } else {
      return (
        <div className="u__text-align--left u__p-top--small buybelt__cannot_be_shipped excludedStateTopPadding">
          <div className="buybelt__cannot_be_shipped__wrapper double-message-for-excluded-state">
            <div>
              <span className="icon-not--available icon-no--boss icon-not-available--single"></span>
              <span className="u__p-right--xsmall u__p-left--small">
                &nbsp;We're unable to ship this item to stores in:&nbsp;
              </span>
              {bossExclusionLocations}
            </div>

            <div>
              <span className="icon-not--available icon-no--sth icon-not-available--single"></span>
              <span className="u__p-right--xsmall u__p-left--small">
                &nbsp;We're unable to ship this item to homes in:&nbsp;
              </span>
              {excludedStates}
            </div>
          </div>
        </div>
      );
    }
  } else {
    return null;
  }
}
export default ExcludedShipStateMessage;
